import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import URL from '@/common/routes/Url';

const AdminAnnounces: React.FC = () => {
  const navigate = useNavigate();

  const toAnnounces = () => {
    navigate(URL.announces);
  };

  return (
    <List dense disablePadding>
      <ListItemButton /*sx={{ pl: 4 }}*/>
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary="アナウンス" onClick={toAnnounces} />
      </ListItemButton>
    </List>
  );
};
export default AdminAnnounces;
